import jwt_decode from 'jwt-decode';

export const decodeToken = (token) => jwt_decode(token);
